import { useDynamicContext } from "@dynamic-labs/sdk-react-core"
import Authenticate from "@/authentication/authenticate"
import { useParams } from "react-router-dom"
import UserSetup from "@/authentication/user-setup"
import PayWithBalance from "./pay-with-balance"

export default function PayWithBalanceScreen() {
  const { isAuthenticated } = useDynamicContext()
  const { shortId } = useParams()

  if (!isAuthenticated) {
    return <Authenticate />
  }

  return (
    <UserSetup>
      <PayWithBalance shortId={shortId!} />
    </UserSetup>
  )
}
